import { makeStyles } from '@material-ui/core';

import { neutral } from '../../../../../../shared/styles/colors';

export default makeStyles(theme => ({
  detailButtonRoot: {
    justifyContent: 'flex-start',
    paddingLeft: '1rem',
    paddingRight: '1rem',
    backgroundColor: neutral[10],
  },
  detailHeader: {
    width: '100%',
  },
  detailHeaderLabel: {
    color: neutral['50'],
    letterSpacing: 1,
    textTransform: 'uppercase',
  },
  detailsListContainer: {
    backgroundColor: neutral[10],
    display: 'grid',
    padding: '12px 16px 18px 16px',
    gridRowGap: 10,
    maxHeight: 250,
    overflow: 'auto',
    [theme.breakpoints.up('md')]: {
      maxHeight: 230,
    },
  },
  detailsListLabel: {
    fontFamily: 'PP Object Sans',
    fontSize: '1rem',
  },
  detailListValue: {
    fontFamily: 'PP Object Sans',
    fontSize: '1rem',
  },
  root: {
    boxShadow: `0 -1px 0 0 ${neutral['20']}`,
    color: neutral['90'],
    lineHeight: 'normal',
  },
  totalContainer: ({ hasDetail }: { hasDetail: boolean }) => ({
    paddingTop: hasDetail ? '2px' : '1.25rem',
    paddingRight: 0,
    paddingBottom: '0.5rem',
    paddingLeft: 0,
  }),
  totalLabel: {
    color: neutral[100],
    fontFamily: 'PP Object Sans',
    fontSize: '1rem',
    fontWeight: 500,
  },
  totalValue: {
    color: neutral[100],
    fontFamily: 'PP Object Sans',
    fontSize: '1rem',
    fontWeight: 700,
  },
}));
